import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

export default function ConfirmDialog({ open, onClose, onConfirm, title, message }) {
  return (
    <Dialog open={open} onClose={() => onClose(false)}>
      <DialogTitle>{title || '确认操作'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message || '确定要执行此操作吗？'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} color="inherit">
          取消
        </Button>
        <Button onClick={() => { onConfirm(); onClose(true); }} color="error" variant="contained">
          确认
        </Button>
      </DialogActions>
    </Dialog>
  );
}
